<template>

</template>

<script>
import router from "@/router";
export default {
  name: "Oauth2Redirect",
  created() {
    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("token")) {
      let token = urlParams.get("token");
      let user = {
        token,
        me: {}
      }
      localStorage.setItem('user', JSON.stringify(user));
      this.$store.dispatch("account/me", {aclChangeRole: this.$acl.change})
      .then(
        () => {
          router.push("/");
        },
        () => {
          router.push("/login");
        }
      )
    } else {
      router.push("/login");
    }
  }
}
</script>

<style scoped>

</style>
